class Emitter {

    constructor() {
        this.events = {};
    }

    on(eventName, callback) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(callback);
    }

    off(eventName, callback) {
        if (!this.events[eventName]) return;
        this.events[eventName] = this.events[eventName].filter((cb) => cb !== callback);
    }

    clear() {
        this.events = {};
    }

    emit(eventName, payload) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].forEach(callback => callback(payload));
    }
}

export { Emitter };
